import { DISPATCH_EVENT_KEYS, SIGNALING_COMMANDS } from 'src/consumer/constants'
import { dispatchWindowSignalingEvent } from 'src/live/signaling/windowSignalingEvents'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithoutParams, postMPDataWithoutParams } from '.'

function normalizeRequestStatus(status) {
  if (!status) return null
  if (typeof status === 'string') return status
  return status?.name || status?.id || null
}

export function normalizeCheckInRequest(rawRequest) {
  if (!rawRequest) {
    return null
  }

  const requestId = rawRequest?.requestId || rawRequest?.id || null
  const status = normalizeRequestStatus(rawRequest?.status)

  return {
    ...rawRequest,
    id: requestId,
    requestId,
    status,
    requestingPractitionerName:
      rawRequest?.requestingPractitionerName || rawRequest?.mentorName || rawRequest?.mentorLabel || null,
    requestingPractitionerId:
      rawRequest?.requestingPractitionerId || rawRequest?.mentorId || rawRequest?.requestingMentorId || null,
    roomAvailable: rawRequest?.roomAvailable === true || status === 'ROOM_AVAILABLE',
  }
}

function getCheckInRequestFromResponse(response) {
  const responseData = getDataMapFromCommonResponse(response)

  return normalizeCheckInRequest(
    responseData?.checkInRequest ||
      response?.data?.checkInRequest ||
      response?.data?.payload?.checkInRequest ||
      response?.data?.payload ||
      null,
  )
}

export function getCheckInRequestErrorMessage(
  response,
  fallbackMessage = 'Could not complete the request.',
) {
  return (
    response?.response?.data?.message ||
    response?.data?.message ||
    response?.message ||
    fallbackMessage
  )
}

export async function createEmrCheckInRequest({ chamberRoomId, reason }) {
  const response = await postMPDataWithoutParams('/api/secure/teacher/emr/checkin-requests', {
    chamberRoomId,
    reason,
  })

  const request =
    response?.status === 200 && isCommonResponseSuccessfulV2(response)
      ? getCheckInRequestFromResponse(response)
      : null

  if (request) {
    dispatchWindowSignalingEvent({
      dispatchEventKey: DISPATCH_EVENT_KEYS.mentorSignalingEvent,
      message: {
        command: SIGNALING_COMMANDS.CHECKIN_REQUEST_CREATED_LOCAL,
        payload: request,
      },
    })
  }

  return {
    response,
    request,
  }
}

export async function respondToEmrCheckInRequest({ requestId, status, notes }) {
  const response = await postMPDataWithoutParams(
    `/api/secure/teacher/emr/checkin-requests/${requestId}/respond`,
    {
      status,
      notes,
    },
  )

  return {
    response,
    request:
      response?.status === 200 && isCommonResponseSuccessfulV2(response)
        ? getCheckInRequestFromResponse(response)
        : null,
  }
}

export async function getLatestOutgoingEmrCheckInRequest() {
  const response = await getMPDataWithoutParams('/api/secure/teacher/emr/checkin-requests/active/outgoing')

  return response?.status === 200 && isCommonResponseSuccessfulV2(response)
    ? getCheckInRequestFromResponse(response)
    : null
}

export async function getLatestIncomingEmrCheckInRequest() {
  const response = await getMPDataWithoutParams('/api/secure/teacher/emr/checkin-requests/active/incoming')

  return response?.status === 200 && isCommonResponseSuccessfulV2(response)
    ? getCheckInRequestFromResponse(response)
    : null
}
